import React from "react";

const TotalSection = (props) => {
  const {
    pasajerosPagantes,
    infoas,
    cargosAdministrativos,
    totalPaqueteConPlanFamily,
    totalPaquete,
    moneda    
  } = props;

  return (
    <div className="total row">
      <h3 className="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-7">
        Total {pasajerosPagantes + infoas} pasajeros
      </h3>
      <h2 className="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-5">
      {moneda}{" "}
        {totalPaqueteConPlanFamily > 0
          ? (totalPaqueteConPlanFamily + cargosAdministrativos)
              .toFixed(2)
              .toLocaleString()
          : totalPaquete.toLocaleString()}
      </h2>
    </div>
  );
};

export default TotalSection;



// WEBPACK FOOTER //
// ./src/components/ProcesoCompra/FichaReserva/totalSection.js